import React, { SVGProps } from 'react';

const SvgYoutubeSolidIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M12 4c2.617 0 5.465.077 7.559.15 1.776.06 3.214 1.443 3.31 3.217.07 1.313.131 2.892.131 4.422 0 1.522-.06 3.092-.13 4.401-.096 1.783-1.546 3.17-3.33 3.229-2.253.075-5.273.158-7.472.158-2.203 0-5.272-.084-7.563-.16a3.466 3.466 0 0 1-3.362-3.273C1.067 14.734 1 13.1 1 11.79c0-1.317.069-2.963.145-4.379a3.45 3.45 0 0 1 3.337-3.262C6.572 4.076 9.4 4 12 4ZM9.849 15l5.636-3.254L9.85 8.491V15Z"
    />
  </svg>
);
SvgYoutubeSolidIcon.defaultProps = {
  width: '24',
  height: '24',
  color: 'currentColor',
};
export default SvgYoutubeSolidIcon;
